import { Radio } from "@mui/material";
import { Controller } from "react-hook-form";
import { RatingValueEnum } from "../../utils/enums/RatingValueEnum";
import ThumbsUpIconSVG from "../../assets/icons/svg/ThumbsUpIconSVG";
import ThumbsDownIconSVG from "../../assets/icons/svg/ThumbsDownIconSVG";
import { FontEnum } from "../../utils/enums/FontEnum";

const ControllerRadioGroupForUserRating = ({ name, control }) => {
    const defaultValue = RatingValueEnum.POSTITIVE;

    const handleChange = (e, field) => {
        const value = Number(e.target.value);
        field.onChange(value);
    };

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field }) => (
                <div style={styles.container}>
                    <div style={styles.option}>
                        <Radio
                            checked={field.value === RatingValueEnum.POSTITIVE}
                            onChange={(e) => handleChange(e, field)}
                            value={RatingValueEnum.POSTITIVE}
                            name="radio-buttons"
                            inputProps={{ "aria-label": RatingValueEnum.POSTITIVE }}
                        />
                        <ThumbsUpIconSVG />
                        <p style={styles.labelText}>Zadovoljavajuće</p>
                    </div>

                    <div style={styles.option}>
                        <Radio
                            checked={field.value === RatingValueEnum.NEGATIVE}
                            onChange={(e) => handleChange(e, field)}
                            value={RatingValueEnum.NEGATIVE}
                            name="radio-buttons"
                            inputProps={{ "aria-label": RatingValueEnum.NEGATIVE }}
                        />
                        <ThumbsDownIconSVG />
                        <p style={styles.labelText}>Nezadovoljavajuće</p>
                    </div>
                </div>
            )}
        />
    );
};

export default ControllerRadioGroupForUserRating;

const styles = {
    container: {
        display: "flex",
        alignItems: "center",
        gap: 40,
    },
    option: {
        display: "flex",
        alignItems: "center",
    },
    labelText: {
        marginLeft: 10,
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "rgba(0, 0, 0, 0.87)",
    },
};
